(function () {
  'use strict';

  function initializeProduct(root) {
    if (!root || root.dataset.tpdInitialized === 'true') return;
    root.dataset.tpdInitialized = 'true';

    var track = root.querySelector('[data-tpd-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-tpd-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tpd-thumb]'));
    var currentIndex = 0;

    function showImage(index) {
      if (!track || !slides.length) return;
      currentIndex = (index + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * currentIndex, behavior: 'smooth' });
      slides.forEach(function (slide, slideIndex) { slide.setAttribute('aria-hidden', slideIndex === currentIndex ? 'false' : 'true'); });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current');
      });
    }

    var previous = root.querySelector('[data-tpd-prev]');
    var next = root.querySelector('[data-tpd-next]');
    if (previous) previous.addEventListener('click', function () { showImage(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { showImage(currentIndex + 1); });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { showImage(Number(thumb.dataset.tpdThumb)); }); });

    if (track) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () { showImage(Math.round(track.scrollLeft / track.clientWidth)); }, 80);
      }, { passive: true });
    }

    var wishlist = root.querySelector('[data-tpd-wishlist]');
    if (wishlist) {
      var key = 'baby-toddle-wishlist';
      var productId = wishlist.dataset.productId;
      var saved = JSON.parse(window.localStorage.getItem(key) || '[]');
      function updateWishlist(active) {
        wishlist.classList.toggle('is-active', active);
        wishlist.setAttribute('aria-pressed', active ? 'true' : 'false');
        wishlist.setAttribute('aria-label', (active ? 'Remove product from' : 'Add product to') + ' wishlist');
      }
      updateWishlist(saved.indexOf(productId) > -1);
      wishlist.addEventListener('click', function () {
        saved = JSON.parse(window.localStorage.getItem(key) || '[]');
        var position = saved.indexOf(productId);
        if (position > -1) saved.splice(position, 1); else saved.push(productId);
        window.localStorage.setItem(key, JSON.stringify(saved));
        updateWishlist(position === -1);
      });
    }

    var variant = root.querySelector('[data-tpd-variant]');
    if (variant) {
      variant.addEventListener('change', function () {
        var option = variant.options[variant.selectedIndex];
        root.querySelector('[data-tpd-variant-id]').value = option.value;
        var price = Number(option.dataset.price || 0);
        var compare = Number(option.dataset.compare || 0);
        var format = JSON.parse(root.querySelector('[data-tpd-money]').textContent || '"${{amount}}"');
        function money(cents) {
          return format.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        }
        root.querySelector('[data-tpd-price]').textContent = money(price);
        var compareEl = root.querySelector('[data-tpd-compare]');
        var saleBadge = root.querySelector('[data-tpd-sale-badge]');
        var onSale = compare > price;
        compareEl.textContent = money(compare);
        compareEl.classList.toggle('is-hidden', !onSale);
        if (saleBadge) {
          var percent = compare > 0 ? Math.round(((compare - price) / compare) * 100) : 0;
          saleBadge.textContent = 'Save ' + percent + '%';
          saleBadge.classList.toggle('is-hidden', !onSale);
        }
      });
    }

    var quantity = root.querySelector('[data-tpd-quantity]');
    if (quantity) {
      var quantityInput = quantity.querySelector('[data-tpd-quantity-input]');
      var minus = quantity.querySelector('[data-tpd-quantity-minus]');
      var plus = quantity.querySelector('[data-tpd-quantity-plus]');
      function setQuantity(nextValue) {
        var value = Math.max(1, Number(nextValue) || 1);
        quantityInput.value = String(value);
      }
      if (minus) minus.addEventListener('click', function () { setQuantity(Number(quantityInput.value) - 1); });
      if (plus) plus.addEventListener('click', function () { setQuantity(Number(quantityInput.value) + 1); });
      quantityInput.addEventListener('change', function () { setQuantity(quantityInput.value); });
    }

    var accordionItems = Array.prototype.slice.call(root.querySelectorAll('.tpd__accordions details')); 
    accordionItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        accordionItems.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function initializeAll() { document.querySelectorAll('[data-tpd-product]').forEach(initializeProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll); else initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();
